import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { NeuButton } from "../../components/neu/Neu";
import { CaptureStatus } from "./CaptureStatus";
import { ReadinessChecklist } from "./ReadinessChecklist";

// The AWS liveness SDK is heavy: keep it out of the main bundle.
const LivenessStage = lazy(() => import("./LivenessStage").then((m) => ({ default: m.LivenessStage })));

// Detector stays mounted only while waiting for the challenge; the camera is released once a result arrives.
export const LivenessPanel = ({ liveness, phase, message, similarity, readiness, checking, onDone, onError, onCancel, onRetry }) => {
  const { t } = useTranslation();
  const capturing = phase === "idle";

  return (
    <>
      {capturing ? (
        liveness.sessionId ? (
          <Suspense fallback={<p className="flex-1 py-10 text-center text-sm">{t("app.loading")}</p>}>
            <LivenessStage
              sessionId={liveness.sessionId}
              region={liveness.region}
              onComplete={onDone}
              onError={onError}
              onCancel={onCancel}
            />
          </Suspense>
        ) : (
          <p className="flex-1 py-10 text-center text-sm" data-testid="liveness-preparing">{t("app.loading")}</p>
        )
      ) : (
        <div className="flex flex-1 items-center justify-center" data-testid="liveness-result-panel">
          <div className="w-full rounded-[28px] p-6 text-center shadow-neu-in">
            <CaptureStatus phase={phase} message={message} similarity={similarity} awsLiveness />
          </div>
        </div>
      )}

      <div className="max-h-[26dvh] shrink-0 overflow-y-auto">
        {capturing ? <CaptureStatus phase={phase} message={message} similarity={similarity} awsLiveness /> : null}
        <ReadinessChecklist readiness={readiness} loading={checking} />
      </div>

      {phase === "error" ? (
        <NeuButton
          variant="primary"
          data-testid="liveness-retry"
          onClick={onRetry}
          className="mt-3 w-full shrink-0 py-4 text-base"
        >
          {t("app.retry")}
        </NeuButton>
      ) : null}
    </>
  );
};
